// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as EmbeddingsAPI from "./embeddings.mjs";
import { Embeddings } from "./embeddings.mjs";
export class Models extends APIResource {
    constructor() {
        super(...arguments);
        this.embeddings = new EmbeddingsAPI.Embeddings(this._client);
    }
    /**
     * List available LLM models using the asynchronous implementation for improved
     * performance.
     *
     * Returns Model format which extends LLMConfig with additional metadata fields.
     * Legacy LLMConfig fields are marked as deprecated but still available for
     * backward compatibility.
     */
    list(query = {}, options) {
        return this._client.get('/v1/models/', { query, ...options });
    }
}
Models.Embeddings = Embeddings;
//# sourceMappingURL=models.mjs.map